import React from 'react';

import { Container } from './styles';

function Badge({ type, children }) {
  return <Container type={type}>{children}</Container>;
}

export default Badge;
